import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Sheet, Loader2 } from "lucide-react";

export default function ProgrammaDialog({ open, onOpenChange }) {
  const [dataDa, setDataDa] = useState("");
  const [dataA, setDataA] = useState("");
  const [busy, setBusy] = useState(false);

  const download = async (format) => {
    setBusy(true);
    try {
      const res = await api.get("/viaggi/programma", {
        params: { data_da: dataDa || undefined, data_a: dataA || undefined, format },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = format === "pdf" ? "programma_viaggio.pdf" : "programma_viaggio.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success("Programma generato");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="programma-dialog">
        <DialogHeader>
          <DialogTitle className="font-head">Programma di viaggio</DialogTitle>
          <DialogDescription>
            Genera il programma raggruppato per autista e ordinato per numero viaggio, in PDF o Excel.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs">Data da</Label>
            <Input type="date" className="mt-1" value={dataDa} onChange={(e) => setDataDa(e.target.value)} data-testid="programma-da" />
          </div>
          <div>
            <Label className="text-xs">Data a</Label>
            <Input type="date" className="mt-1" value={dataA} onChange={(e) => setDataA(e.target.value)} data-testid="programma-a" />
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => download("xlsx")} disabled={busy} data-testid="programma-xlsx">
            {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Sheet className="h-4 w-4 mr-1.5" />}Excel
          </Button>
          <Button onClick={() => download("pdf")} disabled={busy} data-testid="programma-pdf">
            {busy ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileText className="h-4 w-4 mr-1.5" />}PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
